import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { ProdutoFornecedorValor } from 'src/app/models/produto-fornecedor-valor';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';

@Component({
  selector: 'app-alterar-margem-valor-fornecedor-modal',
  templateUrl: './alterar-margem-valor-fornecedor-modal.component.html',
  styleUrls: ['./alterar-margem-valor-fornecedor-modal.component.scss']
})
export class AlterarMargemValorFornecedorModalComponent implements OnInit {
  valores: ProdutoFornecedorValor;
  tipo = 0; // 0 - margem venda | 1 - margem avulso | 2 - valor venda | 3 - valor avulso | 4 - valor custo | 5 - Desc Complementar | 6 - Dt Disponibilidade
  titulo = 'Alterar Margem Preço Venda';
  placeholder = 'Margem Preço Venda';
  valor = 0;

  constructor(
    private dialogRef: MatDialogRef<AlterarMargemValorFornecedorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private produtoService: ProdutoService, private notificacaoService: NotificacaoService, private carregandoService: CarregandoService
  ) {
    this.valores = data.valores;
    this.tipo = data.tipo;
  }

  ngOnInit(): void {
    switch (this.tipo) {
      case 0:
        this.titulo = 'Alterar Margem Preço Venda';
        this.placeholder = 'Margem Preço Venda';
        this.valor = Number(this.valores.margemPrecoVenda);
        break;
      case 1:
        this.titulo = 'Alterar Margem Preço Avulso';
        this.placeholder = 'Margem Preço Avulso';
        this.valor = Number(this.valores.margemPrecoAvulso);
        break;
      case 2:
        this.titulo = 'Alterar Valor Preço Venda';
        this.placeholder = 'Valor Preço Venda';
        this.valor = Number(this.valores.precoVenda);
        break;
      case 3:
        this.titulo = 'Alterar Valor Preço Avulso';
        this.placeholder = 'Valor Preço Avulso';
        this.valor = Number(this.valores.precoAvulso);
        break;

      case 4:
        this.titulo = 'Alterar Valor Preço Custo';
        this.placeholder = 'Valor Preço Custo';
        this.valor = Number(this.valores.precoCusto);
        break;

      case 5:
        this.titulo = 'Alterar Descrição Complementar';
        this.placeholder = 'Descrição Complementar';
        break;

      case 6:
        this.titulo = 'Alterar Data de Disponibilidade';
        this.placeholder = 'Data de Disponibilidade';
        break;

      case 7:
        this.titulo = 'Alterar Estoque';
        this.placeholder = 'Estoque';
        this.valor = Number(this.valores.qtEstoque);
        break;

      default:
        break;
    }
  }

  calcular() {

    if (this.valor === undefined || this.valor === null) return;

    switch (this.tipo) {
      case 0:
        this.valores.margemPrecoVenda = Number(this.valor);
        this.valores.precoVenda = Number((this.valores.precoCusto / (1 - (this.valores.margemPrecoVenda) / 100)).toFixed(2));
        break;

      case 1:
        this.valores.margemPrecoAvulso = Number(this.valor);
        this.valores.precoAvulso = Number((this.valores.precoCusto / (1 - (this.valores.margemPrecoAvulso) / 100)).toFixed(2));
        break;

      case 2:
        this.valores.precoVenda = Number(this.valor);
        this.valores.margemPrecoVenda = Number((100 - (this.valores.precoCusto / this.valores.precoVenda * 100)).toFixed(2));
        break;

      case 3:
        this.valores.precoAvulso = Number(this.valor);
        this.valores.margemPrecoAvulso = Number((100 - (this.valores.precoCusto / this.valores.precoAvulso * 100)).toFixed(2));
        break;

      case 4:
        this.valores.precoCusto = Number(this.valor);
        this.valores.margemPrecoVenda = Number((100 - (this.valores.precoCusto / this.valores.precoVenda * 100)).toFixed(2));
        this.valores.margemPrecoAvulso = Number((100 - (this.valores.precoCusto / this.valores.precoAvulso * 100)).toFixed(2));
        break;

      default:
        break;
    }
  }

  salvar() {


    if (this.tipo === 7)
    {
      this.valores.qtEstoque = Number(this.valor);
    }

    this.carregandoService.mostra('salvaProduto');

    this.produtoService.atualizarValoresFornecedor(this.valores).subscribe(
      (retorno) => {

        this.carregandoService.esconde('salvaProduto');
        this.notificacaoService.sucesso('Operação realizada com sucesso!!!');
        this.dialogRef.close(true);
      },
      (erro) => {
        this.carregandoService.esconde('salvaProduto');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

}
